import { Type } from 'class-transformer';
import { IsBoolean, IsNumber, IsString } from 'class-validator';
import { GiftCardDto } from './giftCard.dto';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class GiftCardTransferDto extends BaseDto {
  @IsString()
  public cardNumber: number;

  @IsString()
  public cvvCode: number;

  @IsNumber()
  public balance: number;

  @IsBoolean()
  public isProcessed?: boolean;

  @IsNumber()
  public giftCardId?: number;

  @IsNumber()
  public merchantId?: number;

  @Type(() => GiftCardDto)
  public giftCard?: GiftCardDto;

  @Type(() => MerchantDto)
  public merchant?: MerchantDto;
}
